<template>
  <!--
  * header 부분 MainHeader.vue로 이동 필요
  * class > header-common에서 header-main으로 변경함
  -->
  <div class="header-main-box">
    <h1 class="new-logo">
      <a href="#" @click.prevent="goToTop()">
        <Logo v-if="!isPooqZone"/>
        <PooqZoneLogo v-if="isPooqZone"/>
      </a>
    </h1>
    <div class="header-item">
      <a href="#" @click.prevent="moveToLive()" class="header-item-live">
        <live-icon />
        <span class="a11y-hidden">LIVE</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Logo from '@/assets/svg/logo/logo.svg'
import PooqZoneLogo from '@/assets/svg/logo/pooqzone.svg'
import LiveIcon from '@/assets/svg/common/ic-live.svg'
import { get } from 'lodash'
import { MENU_LIVE_GN_CODE } from '@/common/menu/menu.const'
import { buildGnbByUiCode } from '@/common/GnbBuilder'
import { getEventListByType } from '@/common/util/event.util'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { PATH_NAME_LIVE } from '@/common/router.const'

export default {
  name: 'MainHeader',
  data () {
    return {
      logoComponent: null,
      showNavbar: true,
      lastScrollPosition: 0,
      lastScrollTop: 0
    }
  },
  components: {
    Logo,
    PooqZoneLogo,
    LiveIcon
  },
  computed: {
    ...mapGetters(['isPooqZone']),
    getLogoClass () {
      return !this.isPooqZone ? 'logo normal' : 'logo pooqzone'
    }
  },
  methods: {
    ...mapMutations({ showLnb: 'showLnb',
      setBeforeOpenMenu: 'setBeforePathOpenMyPooq' }),
    moveToLive () {
      const { onClickEvent } = getEventListByType(get(buildGnbByUiCode(MENU_LIVE_GN_CODE), 'eventlist', []))
      EventBus.$emit(ON_CLICK, onClickEvent)
      this.$router.push({ name: PATH_NAME_LIVE })
    },
    goToTop () {
      document.documentElement.scrollTop = 0
    }
  },
  mounted () {
    this.logoComponent = () => !this.isPooqZone ? Logo : PooqZoneLogo
  }
}
</script>
